import React from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { FileTextOutlined, PlusOutlined } from "@ant-design/icons";
import { EyeOutlined, CalendarOutlined, UserOutlined } from "@ant-design/icons";
import { history } from "../_helpers/history";
import { Button, Card, Empty, Spin, Typography, Tag, Space } from "antd";
import { useItemsFine } from "../_actions/app/items";
import styles from "./styles/QurealBlog.module.css";

const { Title, Text, Paragraph } = Typography;

function QurealBlogPosts() {
    const {
        data: blogs,
        isLoading,
        error,
    } = useItemsFine("qblog_posts", "fields=*");

    const handleViewBlog = (blogId) => {
        history.push(`/ecommerce/blogs/${blogId}`, {
            from: history.location.pathname,
        });
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    return (
        <QurealSection
            header={
                <SectionHeader heading="Blog Posts" icon={<FileTextOutlined />}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                            history.push(`/ecommerce/blogs/create`, {
                                from: history.location.pathname,
                            });
                        }}
                    >
                        Create New
                    </Button>
                </SectionHeader>
            }
        >
            {isLoading ? (
                <div className={styles.spinnerContainer}>
                    <Spin size="large" />
                </div>
            ) : error ? (
                <div className={styles.errorContainer}>
                    <Text type="danger">
                        Error loading blog posts: {error.message}
                    </Text>
                </div>
            ) : blogs?.length > 0 ? (
                <div className={styles.blogGrid}>
                    {blogs.map((blog) => (
                        <Card
                            key={blog.id}
                            hoverable
                            className={styles.blogCard}
                            onClick={() => handleViewBlog(blog.id)}
                        >
                            <div className={styles.blogCardContent}>
                                <div className={styles.blogMeta}>
                                    <Space size={4}>
                                        <Tag
                                            color={
                                                blog.status === "published"
                                                    ? "green"
                                                    : "orange"
                                            }
                                        >
                                            {blog.status === "published"
                                                ? "Published"
                                                : "Draft"}
                                        </Tag>
                                        {blog.status === "published" && (
                                            <Text type="secondary">
                                                <CalendarOutlined />{" "}
                                                {formatDate(
                                                    blog.published_date
                                                )}
                                            </Text>
                                        )}
                                    </Space>
                                </div>

                                <Title level={4} className={styles.blogTitle}>
                                    {blog.title}
                                </Title>

                                <Paragraph
                                    ellipsis={{ rows: 3 }}
                                    className={styles.blogExcerpt}
                                >
                                    {blog.excerpt ||
                                        blog.body
                                            .replace(/<[^>]*>/g, "")
                                            .substring(0, 120) + "..."}
                                </Paragraph>

                                <div className={styles.blogCardFooter}>
                                    <Text type="secondary">
                                        <UserOutlined />{" "}
                                        {blog.owner?.first_name ||
                                            "Unknown Author"}
                                    </Text>
                                    <Button type="link" size="small">
                                        <EyeOutlined /> Read More
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            ) : (
                <Empty
                    description="No blog posts found"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            )}
        </QurealSection>
    );
}

export default QurealBlogPosts;
